import React, { useState, useEffect } from "react";
import { getCoursesApi } from "../../api/course";
import CoursesList from "../../components/Admin/Courses/CoursesList";

export default function Courses() {
  const [courses, setCourses] = useState([]); //los cursos son objetos
  const [reloadCourses, setReloadCourses] = useState(false);

  useEffect(() => {
    getCoursesApi().then((response) => {
      setCourses(response.courses);
    });
    setReloadCourses(false);
  }, [reloadCourses]);

  return (
    <div className="courses">
      <CoursesList courses={courses} setReloadCourses={setReloadCourses} />
    </div>
  );
}
